// صفحه‌ی «همه»ی دسته‌های سلر آکادمی (route: seller-academy-all-categories) زیر
// /seller-academy نیست، ولی باید هدر سلر آکادمی بگیرد.
const SELLER_ACADEMY_PREFIXES = ["/seller-academy", "/all-seller-academy-categories"];

const is_seller_academy_path = (pathname = "") =>
    SELLER_ACADEMY_PREFIXES.some((prefix) => pathname.startsWith(prefix));

export default is_seller_academy_path;
